import { jsx, jsxs } from "react/jsx-runtime";
import { ConfirmActionDialogWidget } from "@brandclub/bc-widgets";
const ConfirmActionDialog = ({
  open,
  title,
  message,
  confirmText = "Confirm",
  cancelText = "Cancel",
  onConfirm,
  onCancel
}) => {
  if (!open) {
    return null;
  }
  return /* @__PURE__ */ jsx(
    ConfirmActionDialogWidget,
    {
      widgetId: "concierge-confirm-action-dialog",
      displayName: "Confirm Action Dialog",
      overlay: (state, resolveColor) => /* @__PURE__ */ jsx(
        "div",
        {
          style: { backgroundColor: resolveColor(state.overlayBgColor) },
          className: "tw:fixed tw:inset-0 tw:z-[10000]",
          onClick: onCancel
        }
      ),
      children: (state, resolveColor) => /* @__PURE__ */ jsx(
        "div",
        {
          className: "tw:fixed tw:inset-0 tw:z-[10001] tw:flex tw:items-center tw:justify-center tw:px-4",
          children: /* @__PURE__ */ jsxs(
            "div",
            {
              className: "tw:w-full tw:max-w-md tw:p-5 tw:shadow-2xl",
              style: {
                backgroundColor: resolveColor(state.dialogBgColor),
                borderRadius: `${state.dialogBorderRadius}px`
              },
              onClick: (event) => event.stopPropagation(),
              children: [
                /* @__PURE__ */ jsx(
                  "h3",
                  {
                    className: "tw:text-base tw:font-semibold",
                    style: { color: resolveColor(state.titleColor) },
                    children: title
                  }
                ),
                /* @__PURE__ */ jsx(
                  "p",
                  {
                    className: "tw:mt-2 tw:text-sm",
                    style: { color: resolveColor(state.messageColor) },
                    children: message
                  }
                ),
                /* @__PURE__ */ jsxs("div", { className: "tw:mt-5 tw:flex tw:justify-end tw:gap-2", children: [
                  /* @__PURE__ */ jsx(
                    "button",
                    {
                      type: "button",
                      onClick: onCancel,
                      className: "tw:rounded-md tw:border tw:px-3 tw:py-2 tw:text-sm tw:font-medium hover:tw:opacity-90",
                      style: {
                        backgroundColor: resolveColor(state.cancelButtonBgColor),
                        borderColor: resolveColor(state.cancelButtonBorderColor),
                        color: resolveColor(state.cancelButtonTextColor)
                      },
                      children: cancelText
                    }
                  ),
                  /* @__PURE__ */ jsx(
                    "button",
                    {
                      type: "button",
                      onClick: onConfirm,
                      className: "tw:rounded-md tw:px-3 tw:py-2 tw:text-sm tw:font-medium hover:tw:opacity-90",
                      style: {
                        backgroundColor: resolveColor(state.confirmButtonBgColor),
                        color: resolveColor(state.confirmButtonTextColor)
                      },
                      children: confirmText
                    }
                  )
                ] })
              ]
            }
          )
        }
      )
    }
  );
};
export {
  ConfirmActionDialog
};
//# sourceMappingURL=ConfirmActionDialog.js.map
